import { useState } from "react";
import AddressSection from "../../components/Checkout/AddressSection";
import ShippingSection from "../../components/Checkout/ShippingSection";
import PaymentSection from "../../components/Checkout/PaymentSection";
import OrderSummary from "../../components/Checkout/OrderSummary";
import AddressForm from "../../components/Checkout/AddressForm";

export default function Checkout() {
  const [addresses, setAddresses] = useState([]);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [cartItems, setCartItems] = useState([]); // Mock: []

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-8 text-center">
          Confirmação de Compra
        </h1>

        {showAddressForm ? (
          <AddressForm
            onSave={(newAddress) => {
              setAddresses([...addresses, newAddress]);
              setShowAddressForm(false);
            }}
            onCancel={() => setShowAddressForm(false)}
          />
        ) : (
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="lg:w-2/3 space-y-6">
              <AddressSection
                addresses={addresses}
                setShowAddressForm={setShowAddressForm}
              />
              <ShippingSection />
              <PaymentSection />
            </div>

            <div className="lg:w-1/3">
              <OrderSummary items={cartItems} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
